export default __webpack_public_path__ + "static/media/student.964c0656.png";